import * as React from "react";
import * as S from "@styled";
import { FocusEvent } from "../../shared/model/Event";
import { EditorProps } from "./EnvironmentVariableEditor";

export class StringEditor extends React.Component<React.PropsWithChildren<EditorProps<string>>, { value: string }> {

    constructor(props: EditorProps<string>) {
        super(props);
        this.state = {
            value: this.props.value // ACC-7836: Just store the initial value and do nothing with it until we check it when the user has actually made a change to the field
        };
    }

    public shouldComponentUpdate(nextProps: EditorProps<string>) {
        if (nextProps.value !== this.props.value) {
            return true;
        }
        return false;
    }

    public render() {
        let rowsInText = this.props.value && this.props.value.split(/\r\n|\r|\n/).length || 1;
        rowsInText = rowsInText > 5 ? 5 : rowsInText;

        return (
            <S.FlexContainer noWrap={true}>
                <S.TextArea
                    rows={rowsInText}
                    key={this.props.value || ""}
                    placeholder={this.props.value === "" ? FRENDS.Localizations.NotSet : undefined}
                    className="string-editor-selector"
                    defaultValue={this.props.value || ""}
                    onBlur={this.handleBlur}
                />
                {this.props.children}
            </S.FlexContainer>
        );
    }

    private handleBlur = (event: FocusEvent<HTMLTextAreaElement>) => {
        if (event.target.value !== this.state.value) {
            this.props.updateSingleValue(event.target.value, this.props.environmentId);
            this.setState({ value: event.target.value });
        }
    }
}
